
<div class="reset-password">
  <button class="reset-password__button" (click)="resetPasswordClick()"
          *ngIf="resetPasswordStep === 1" i18n>
    Сбросить пароль
  </button>
  <div class="reset-password__request" *ngIf="resetPasswordStep === 2">
    <span i18n>Отправка запроса</span>
    <app-spinner size="24px"></app-spinner>
  </div>
  <p class="reset-password__new-password" *ngIf="resetPasswordStep === 3" i18n
     [cdkCopyToClipboard]="newPassword" (cdkCopyToClipboardCopied)="passwordCopied()">
    {{ newPassword }}
  </p>
</div>

<app-modal-wrapper *ngIf="showResetConfirmation">
  <app-modal-content successBtnContent="Да" i18n-successBtnContent
                     (successModal)="resetPassword()"
                     (closeModal)="showResetConfirmation = false">
    <p class="reset-password-confirm" i18n="@@4368972123951048842">
      Вы уверены, что хотите сбросить существующий пароль пользователя?
    </p>
  </app-modal-content>
</app-modal-wrapper>
